module.exports = __webpack_public_path__ + "img/handshake-plein-bleu.svg";